import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./translations/en";
import fr from "./translations/fr";

const resources = {
    en: {
        translation: en,
    },
    fr: {
        translation: fr,
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        keySeparator: false,
        nsSeparator: false,
        interpolation: {
            escapeValue: false,
        },
    });

export const translateGridText = (params) => {
    //   console.log(i18next.t(`ag-grid.${params.key}`, params.defaultValue));
    return i18next.t(`ag-grid.${params.key}`, params.defaultValue);
};

export default i18n;
